// extracted by mini-css-extract-plugin
export default {"stickyTabsAnchor":"twfkIV","tabs":"mID7oo","sticky":"aIybx_","tab":"GC7bjC","selected":"VjvTKq"};